type Props = {
  label: string;
  value: string | any;
};
export default function DetailCardItem({ label, value }: Props) {
  return (
    <div className="flex gap-[44px] items-center">
      <div className="min-w-[68px] text-sm text-gray-B font-semibold">
        {label}
      </div>
      <div className="text-sm text-gray-A font-normal">{value}</div>
    </div>
  );
}
